import { render, staticRenderFns } from "./PptShape.vue?vue&type=template&id=edaa9710&"
import script from "./PptShape.vue?vue&type=script&lang=js&"
export * from "./PptShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edaa9710')) {
      api.createRecord('edaa9710', component.options)
    } else {
      api.reload('edaa9710', component.options)
    }
    module.hot.accept("./PptShape.vue?vue&type=template&id=edaa9710&", function () {
      api.rerender('edaa9710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptShape.vue"
export default component.exports